module.exports = __webpack_public_path__ + "img/pauli-x-root-dagger-24.a7d508bd.svg";